import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="bg-white" data-id="element-354" data-mp="3mf7rslfibwe5">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-20" data-id="element-355" data-mp="3r7iq5julna4l">
        <SectionHeading title={<>What other parents <em className="text-coral" data-id="element-357" data-mp="1hkxrxbfaqv">are saying</em></>} data-id="element-356" data-mp="3r93mnf0h5353" />

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-358" data-mp="y288zucibs">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-359" data-mp="44w0yil97r4b">
              <div className="flex items-center gap-4" data-id="element-360" data-mp="92ff7ihyc3w9">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-361" data-mp="e1ik92xxma48" />
                <div data-id="element-362" data-mp="2autvkd4ul0ak">
                  <p className="text-lg font-black text-navy" data-id="element-363" data-mp="2avlrjp2cx01d">{t.name}</p>
                  <p className="text-sm font-semibold text-muted" data-id="element-364" data-mp="2fsvnlnk949y6">{t.location}</p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-365" data-mp="1slko564pswet">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-sun text-sun" aria-hidden="true" data-id="element-366" data-mp="1nrzshkqlgeis" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <h3 className="mt-5 font-display text-xl font-bold leading-snug text-navy" data-id="element-367" data-mp="1er1kysgy5ovg">“{t.headline}”</h3>
              <p className="mt-2 text-[17px] leading-relaxed text-muted" data-id="element-368" data-mp="2bh14fhymy7st">{t.quote}</p>
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-369" data-mp="22i7ajzcovviy">
          <CTAButton label="I want to feel more prepared" data-id="element-370" data-mp="22hdz4l2schuh" />
        </div>
      </div>
    </section>;
}